import React, { Component, Fragment } from 'react'
import _ from 'lodash'
import { Menu, Image, Icon, Accordion } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import utils from '../utils'
import MENUS from './Menus'

const logo = require('../assets/images/muuve-full.png')

const styles = {
  iconMarginRight: {
    marginRight: '10px',
  },
  subMenuItems: {
    padding: 0,
  },
}

export default class MainNavigation extends Component {
  state = {
    activeIndex: 0,
  }

  componentDidMount() {
    const { pathname } = window.location
    let activeIndex = 0

    _.forEach(MENUS, (menu, index) => {
      if (menu.subMenuItems) {
        const isExisted = _.some(menu.subMenuItems, { route: { pathname } })

        if (isExisted) {
          activeIndex = index
        }
      } else if ({ pathname } === menu.route) {
        activeIndex = index
      }
    })

    this.setState({ activeIndex })
  }

  handleClick = index => {
    let { activeIndex } = this.state
    activeIndex = activeIndex === index ? -1 : index

    this.setState({ activeIndex })
  }

  isActive = path => {
    return window.location.pathname.includes(path)
  }

  renderModule = ({ title, icon, route }, isSubMenu = false) => {
    const key = route.replace('/', '')
    const paddingLeft = isSubMenu ? { paddingLeft: 30 } : {}

    return (
      <Link to={route} key={key}>
        <Menu.Item active={this.isActive(route)} style={paddingLeft}>
          <span>
            <Icon className={icon} style={styles.iconMarginRight} />
            {title}
          </span>
        </Menu.Item>
      </Link>
    )
  }

  renderMenu = accessableModules => {
    const menusToRender = []

    MENUS.forEach((menu, index) => {
      if (menu.subMenuItems) {
        const hasSubMenus = _.some(menu.subMenuItems, item => accessableModules.includes(item.module))

        if (hasSubMenus) menusToRender.push(this.renderMultipleLevelMenu(index, menu, accessableModules))
      } else if (accessableModules.includes(menu.module)) {
        menusToRender.push(this.renderModule(menu))
      }
    })

    return menusToRender
  }

  renderMultipleLevelMenu = (index, menu, accessableModules) => {
    const { activeIndex } = this.state

    return (
      <Fragment key={`${index}${menu.title}`}>
        <Accordion.Title
          active={activeIndex === index}
          index={index}
          onClick={() => this.handleClick(index)}
          style={{
            padding: 0,
          }}
        >
          <Menu.Item>
            <span>
              <Icon className={menu.icon} style={styles.iconMarginRight} />
              {menu.title}
              <Icon name={activeIndex === index ? 'angle up' : 'angle down'} style={{ float: 'right' }} />
            </span>
          </Menu.Item>
        </Accordion.Title>
        <Accordion.Content active={activeIndex === index} style={styles.subMenuItems}>
          {this.renderSubMenu(menu.subMenuItems, accessableModules)}
        </Accordion.Content>
      </Fragment>
    )
  }

  renderSubMenu = (subMenuItems, accessableModules) => {
    const subMenusToRender = []

    _.forEach(subMenuItems, subMenuItem => {
      if (accessableModules.includes(subMenuItem.module)) {
        subMenusToRender.push(this.renderModule(subMenuItem, true))
      }
    })

    return subMenusToRender
  }

  renderSideMenu = () => {
    const { roles, authData } = this.props

    if (authData.role && roles[authData.role] && roles[authData.role].access) {
      const { access: accessableModules } = roles[authData.role]

      return <Accordion className="side-menu-wrapper">{this.renderMenu(accessableModules)}</Accordion>
    }

    return null
  }

  renderVersion() {
    return <div className="version-wrapper">{utils.constants.version}</div>
  }

  render() {
    const { sideBarVisible } = this.props

    return (
      <Menu
        vertical
        inverted
        fixed="left"
        style={{
          transition: 'all 0.4s',
          left: sideBarVisible ? 0 : '-15rem',
          overflow: 'auto',
          height: '100vh',
        }}
      >
        <Menu.Item
          style={{
            height: '100px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Image src={logo} size="small" verticalAlign="middle" centered />
        </Menu.Item>
        {this.renderSideMenu()}
        {this.renderVersion()}
      </Menu>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/MainNavigation.js